module.exports = __webpack_public_path__ + "img/step_4-1-1.c9872312.png";